module.exports = __webpack_public_path__ + "static/images/fill-empty.216bbcb773f6dd6c588f7e3b7c25c314.svg";